import { useRef } from "react"
import { Chat } from "@/reducers/chatsSlice"
import ChatMap from "@/components/maps/ChatMap"

type Props = {
  chat: Chat
  driverJid: string
}

/**
 * `ChatMap` (bare) wrapped with its own container ref, so the map sizes to
 * whichever widget pane it lands in rather than to the centre chat column.
 */
const MapWidgetBody = ({ chat, driverJid }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  return (
    <div ref={ref} className="h-full min-h-0">
      <ChatMap
        bare
        hideRoutePanel
        chat={chat}
        driverJid={driverJid}
        chatContainerRef={ref}
      />
    </div>
  )
}

export default MapWidgetBody
